export const submissionEndpoints = {
  submit: (schemaId) => `/submissions/submit/${schemaId}`,
  getAll: "/submissions",
  getById: (id) => `/submissions/${id}`,
  getBySector: (sector) => `/submissions/sector/${sector}`,
  getByReport: (reportId) => `/submissions/report/${reportId}`,
  excelTemplate: (reportId) => `/submissions/excel-template/${reportId}`,
  importExcel: (reportId) => `/submissions/import-excel/${reportId}`,
};

